import { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { FaFacebook, FaGithub, FaLinkedin, FaXing } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/Logo/logo.png";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  const navigationLinks = (
    <>
      <NavLink to="/home" className="text-2xl font-bold mr-4">
        Home
      </NavLink>
      {/* <NavLink className="text-2xl font-bold mr-4">Skills</NavLink> */}
      {/* <NavLink className="text-2xl font-bold mr-4">About Me</NavLink> */}
      <NavLink to="/blogs" className="text-2xl font-bold mr-4">
        Blogs
      </NavLink>
    </>
  );

  return (
    <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Link className="w-32" to="/">
          <img src={logo} alt="Logo" />
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">{navigationLinks}</Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a href="https://github.com/HasanMdKamrul">
                <span>
                  <FaGithub className="text-white " />
                </span>
              </a>
              <a href="https://www.linkedin.com/in/md-kamrul-hasan-590809171/">
                <span>
                  <FaLinkedin className="text-white " />
                </span>
              </a>
              <a href="https://www.xing.com/profile/MDKAMRUL_HASAN13/cv">
                <span>
                  <FaXing className="text-white " />
                </span>
              </a>
              <a href="https://www.facebook.com/kamrulhasan.tanmoy.79/">
                <span>
                  <FaFacebook className="text-white " />
                </span>
              </a>
            </div>
            {/* <HashLink to="#connect"> */}
            <button className="vvd rounded rounded-3">
              <span>Let’s Connect</span>
            </button>
            {/* </HashLink> */}
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
